import ky, { Options } from 'ky';
import { ENDPOINT } from '~/constants';

import { isAbortError } from '@vestigas/data';

import { log } from '~/utils';

import { RELEASE_NOTES_BASE_URL } from './constants';
import { ReleaseNotesQueryParams } from './types';
import { getReleaseNotesFileName } from './utils';
import { zodReleaseNotesQueryParamsSchema } from './validations';

/**
 * Fetches the release notes for the customer portal from a storage bucket.
 * @param queryParams - The query parameters for fetching the release notes.
 * @param options - Additional options for the fetch request.
 * @returns The release notes as a string.
 */
export const fetchReleaseNotes = async (
  queryParams: ReleaseNotesQueryParams,
  options?: Options,
) => {
  try {
    const validatedQueryParams = zodReleaseNotesQueryParamsSchema.parse(
      queryParams ?? {},
    );

    const fileName = getReleaseNotesFileName({
      app: validatedQueryParams.app,
      environment: validatedQueryParams.environment,
      language: validatedQueryParams.language,
    });

    const response = await ky
      .get(ENDPOINT.RELEASE_NOTES.GET(fileName), {
        prefixUrl: RELEASE_NOTES_BASE_URL,
        retry: 0, // Disable retries (managed by react-query)
        timeout: false, // Disable timeouts (managed by react-query)
        ...options,
      })
      .text();

    return response;
  } catch (error) {
    if (isAbortError(error)) {
      return '';
    }

    log.error({
      message: 'Error fetching release notes',
      error,
    });

    // Don't handle errors with errorFactory
    return '';
  }
};
